<template>
    <div class="base-header">
        <div class="back_left" @click="$router.go(-1)"></div>
        <div class="big_tit">{{title}}</div>
    </div>
</template>

<script>
export default {
    name: "baseHeader",
    props:{
        title:String
    }
}
</script>

<style scoped lang="less">
    .base-header
    {
        height: 45px;
        width: 100%;
        display: flex;
        // background: rgb(29, 40, 70);
        background: rgb(13, 9, 32);
        position: absolute;
        top: 0;
    }
    .back_left{
        width: 35px;
        height: 44px;
        background: url("../views/images/item/back.png") no-repeat;
        background-size: 14px 20px;
        background-position: center;
        position: absolute;
    }
    .big_tit {
        position: absolute;
        height: 25px;
        font-size: 18px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 25px;
        top: 12px;
        left: 50%;
        transform: translateX(-50%);
    }
</style>